import KunLoading59 from './src/index'

KunLoading59.install = function (Vue) {
	Vue.component(KunLoading59.name, KunLoading59);
}

export default KunLoading59;
